import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Gauge, X } from 'lucide-react';
import { myVehiclesAPI } from '../services/api';

const STALE_DAYS = 90;

// Discreet, dismissable bar asking logged-in users to refresh a vehicle mileage (missing or older than 90 days)
export const MileagePrompt = ({ user }) => {
  const [vehicle, setVehicle] = useState(null);
  useEffect(() => {
    if (!user || sessionStorage.getItem('mileage-prompt-dismissed')) return;
    myVehiclesAPI.list().then((list) => {
      const stale = list.find((v) => v.mileage == null || (Date.now() - new Date(v.mileage_updated_at || v.created_at)) / 86400000 > STALE_DAYS);
      setVehicle(stale || null);
    }).catch(() => {});
  }, [user]);
  if (!vehicle) return null;
  const dismiss = () => { sessionStorage.setItem('mileage-prompt-dismissed', '1'); setVehicle(null); };
  return (
    <div className="bg-blue-50 border-b border-blue-100 text-blue-900" data-testid="mileage-prompt">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3 text-sm">
        <Gauge size={16} className="shrink-0 text-blue-600" />
        <span className="flex-1 min-w-0 truncate">{vehicle.mileage == null ? `Quel est le kilométrage de votre ${vehicle.brand} ${vehicle.model} ?` : `Votre kilométrage ${vehicle.brand} ${vehicle.model} date de plus de 3 mois.`} Mettez-le à jour pour recevoir vos rappels d'entretien au bon moment.</span>
        <Link to="/mon-compte/entretien" onClick={dismiss} className="shrink-0 bg-blue-600 text-white text-xs font-medium px-3 py-1 rounded-full hover:bg-blue-700" data-testid="mileage-prompt-link">Renseigner</Link>
        <button type="button" onClick={dismiss} className="shrink-0 text-blue-400 hover:text-blue-700" aria-label="Fermer" data-testid="mileage-prompt-close"><X size={16} /></button>
      </div>
    </div>
  );
};

export default MileagePrompt;
